import React, { RefObject, useEffect, useState } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { LOGO, LOGO_SECOND } from "../../assets";
import ImagePreview from "../ImagePreview";
import ReloadAnimation from "../ReloadAnimation";
import { IssuedTicketDetailType } from "../../types";
import moment from "moment";

interface Props {
  visibility: boolean;
  isPrinting: boolean;
  data: IssuedTicketDetailType;
  refContainer: RefObject<HTMLDivElement>;
  qr: {
    encodeImage: string;
    lifeSpanEnd: string;
    issuedEkaSerial: string;
  } | null;
  componentRef: React.MutableRefObject<HTMLDivElement | null>;
}
const IssuedTicketDetailContent: React.FC<Props> = ({
  visibility,
  data,
  qr,
  refContainer,
  isPrinting,
  componentRef,
}) => {
  const [issuedEkaSerial, setIssuedEkaSerial] = useState<string>("");

  useEffect(() => {
    if (visibility && qr?.issuedEkaSerial) {
      setIssuedEkaSerial(qr.issuedEkaSerial);
    }
  }, [visibility, qr]);

  return (
    <Paper
      sx={{
        p: isPrinting ? 0 : 2,
        my: isPrinting ? 0 : 2,
        ml: isPrinting ? "-3.54px" : 0,
      }}
      ref={componentRef}
    >
      <Grid
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "row",
          alignItems: "center",
          mt: 1,
          mb: 1,
          ...(isPrinting && { mr: 6 }),
        }}
      >
        {visibility && (
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: isPrinting ? "8px" : "0.8rem",
              marginRight: "80px",
            }}
          >
            {issuedEkaSerial}
          </Typography>
        )}
      </Grid>
      <Grid
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          ...(isPrinting ? { mb: 1 } : { mt: 8, mb: 4 }),
        }}
      >
        {data?.label?.top ? (
          <img
            src={data?.label?.top}
            // width={isPrinting ? 35 : 80}
            // height={isPrinting ? 35 : 80}
            width={isPrinting ? 35 : 100}
            height={isPrinting ? 35 : 100}
            crossOrigin="anonymous"
            alt="Top label"
          />
        ) : (
          <ImagePreview
            img={LOGO_SECOND}
            // width={isPrinting ? 35 : 80}
            //   height={isPrinting ? 35 : 80}
            width={isPrinting ? 35 : 100}
            height={isPrinting ? 35 : 100}
          />
        )}
      </Grid>
      <Grid
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          position: "relative",
        }}
      >
        {visibility ? (
          <ReloadAnimation>
            <Box ref={refContainer} sx={{ height: "220px", width: "220px" }}></Box>
          </ReloadAnimation>
        ) : (
          <Box sx={{ height: "20px", width: "20px" }}></Box>
        )}
      </Grid>
      {visibility && (
        <Grid sx={{ my: isPrinting ? 1 : 2 }}>
          <Typography
            align="center"
            // sx={{ fontWeight: 600, fontSize: isPrinting ? "8px" : "0.8rem" }}
            sx={{ fontWeight: 600, fontSize: isPrinting ? "8px" : "0.9rem" }}
          >
            有効期限
          </Typography>
          <Typography
            align="center"
            // sx={{ fontWeight: 600, fontSize: isPrinting ? "10px" : "0.8rem" }}
            sx={{ fontWeight: 600, fontSize: isPrinting ? "10px" : "0.9rem" }}
          >
            {qr?.lifeSpanEnd && parseFloat(qr?.lifeSpanEnd) > 0
              ? moment.unix(parseFloat(qr.lifeSpanEnd)).format("YYYY/MM/DD HH:mm")
              : "無制限"}
          </Typography>
        </Grid>
      )}
      <Grid
        sx={{ my: isPrinting ? 0 : 4 }}
        >
        <Typography
          align="center"
          sx={{
            fontWeight: 600,
            // fontSize: isPrinting ? "8px" : "1.0rem",
            fontSize: isPrinting ? "8px" : "1.1rem",
            wordWrap: "break-word",
            wordBreak: "break-all",
          }}
        >
          {data?.store?.name} {data?.store?.subname}
        </Typography>
        <Typography
          align="center"
          sx={{
            fontWeight: 600,
            // fontSize: isPrinting ? "10px" : "1.0rem",
            fontSize: isPrinting ? "10px" : "1.1rem",
            wordWrap: "break-word",
            wordBreak: "break-all",
          }}
        >
          {data?.ticket?.name}
        </Typography>
      </Grid>
      <Grid
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          ...(isPrinting ? {} : { my: 8 })
        }}
      >
        {data?.label?.bottom ? (
          <img
            src={data?.label?.bottom}
            // width={isPrinting ? 35 : 80}
            // height={isPrinting ? 35 : 80}
            width={isPrinting ? 35 : 100}
            height={isPrinting ? 35 : 100}
            crossOrigin="anonymous"
            alt="Bottom label"
          />
        ) : (
          <ImagePreview
            img={LOGO}
            // width={isPrinting ? 35 : 80}
            // height={isPrinting ? 35 : 80}
            width={isPrinting ? 35 : 100}
            height={isPrinting ? 35 : 100}
          />
        )}
      </Grid>
    </Paper>
  );
};

export default IssuedTicketDetailContent;
